var map = {
	"./badkamer-vastgoed-c-orange.svg": "./resources/svg/badkamer-vastgoed-c-orange.svg",
	"./bed-vastgoed-c-orange.svg": "./resources/svg/bed-vastgoed-c-orange.svg",
	"./bouwjaar-vastgoed-c-orange.svg": "./resources/svg/bouwjaar-vastgoed-c-orange.svg",
	"./chevron-down.svg": "./resources/svg/chevron-down.svg",
	"./chevron-left.svg": "./resources/svg/chevron-left.svg",
	"./chevron-right.svg": "./resources/svg/chevron-right.svg",
	"./close-vastgoed-c-orange.svg": "./resources/svg/close-vastgoed-c-orange.svg",
	"./document.svg": "./resources/svg/document.svg",
	"./documents-vastgoed-c-orange.svg": "./resources/svg/documents-vastgoed-c-orange.svg",
	"./google-maps-marker-detail-vastgoed-c-orange.svg": "./resources/svg/google-maps-marker-detail-vastgoed-c-orange.svg",
	"./google-maps-marker-vastgoed-c-orange.svg": "./resources/svg/google-maps-marker-vastgoed-c-orange.svg",
	"./grondoppervlakte-vastgoed-c-orange.svg": "./resources/svg/grondoppervlakte-vastgoed-c-orange.svg",
	"./huis-vastgoed-c-orange.svg": "./resources/svg/huis-vastgoed-c-orange.svg",
	"./locatie-vastgoed-c-orange.svg": "./resources/svg/locatie-vastgoed-c-orange.svg",
	"./location_shape.svg": "./resources/svg/location_shape.svg",
	"./logo-vastgoed-c.svg": "./resources/svg/logo-vastgoed-c.svg",
	"./phone.svg": "./resources/svg/phone.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/svg sync recursive ^\\.\\/.*$";